import React from "react";

/**
 * component svg 
 */
const NoSearchResults = function (props) {

    return (
        <svg version="1.1" id="no-results" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 1000 1000">
            <circle className="st0-no-results" cx="585.3" cy="419.7" r="271.7"/>
            <line className="st3-no-results" x1="111.2" y1="894" x2="393.2" y2="611.8"/>
            <path className="st1-no-results" d="M460.6,533c83.1-20,166.2-20,249.4,0"/>
            <line className="st2-no-results" x1="683.8" y1="329" x2="683.8" y2="337"/>
            <line className="st2-no-results" x1="512.8" y1="329" x2="512.8" y2="337"/>
        </svg>
    );
};

export default NoSearchResults;